import { players } from './PlayersEntries';

const fallback = players[0];

export const getActivePlayer = (src?: string) => {
  for (const player of players) {
    if (src && player.canPlay(src)) {
      return player;
    }
  }

  if (fallback) {
    return fallback;
  }

  return null;
};
